import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiPaths } from '../_enums/api-paths';

const httpOptions = {
  headers: new HttpHeaders({ 'Accept': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class TemplateService { 
  baseUrl = environment.baseUrl;

  constructor(
    private http: HttpClient
  ) { }

  getTemplatesTypes$(uuid: string): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.templates}`;
    return this.http.get<any>(url + 'types?uuid=' + uuid);
  }

  getTemplatesList$(uuid: string): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.templates}`;
    return this.http.get<any>(url + 'list?uuid=' + uuid);
  }

  getTemplate$(templateId: number, uuid: string): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.templates}`;
    return this.http.get<any>(url + '?template_id=' + templateId + '&uuid=' + uuid);
  }

  addTemplate$(uuid: string, templateInfo: any): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.templates}`;
    return this.http.post<any>(url + '?uuid=' + uuid, templateInfo, httpOptions);
  }

  updateTemplate$(uuid: string, templateInfo: any): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.templates}`;
    return this.http.put<any>(url + '?uuid=' + uuid, templateInfo, httpOptions);
  }

}
